import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = { class: "widget-container" }
const _hoisted_3 = {
  class: "rotating-arcs",
  viewBox: "0 0 200 200"
}
const _hoisted_4 = ["stroke"]
const _hoisted_5 = {
  class: "rotating-arcs",
  style: {"animation-delay":"-4s"},
  viewBox: "0 0 200 200"
}
const _hoisted_6 = ["stroke"]
const _hoisted_7 = { class: "risk-value" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(), _createElementBlock("svg", _hoisted_3, [
        _createElementVNode("path", {
          d: "M 100,45 A 55,55 0 0,1 155,100",
          fill: "none",
          stroke: `${_ctx.riskColor}4D`,
          "stroke-width": "4"
        }, null, 8, _hoisted_4)
      ])),
      (_openBlock(), _createElementBlock("svg", _hoisted_5, [
        _createElementVNode("path", {
          d: "M 100,45 A 55,55 0 0,1 155,100",
          fill: "none",
          stroke: `${_ctx.riskColor}4D`,
          "stroke-width": "4"
        }, null, 8, _hoisted_6)
      ])),
      _createElementVNode("div", {
        class: "central-circle",
        style: _normalizeStyle({ background: _ctx.riskColor })
      }, [
        _cache[0] || (_cache[0] = _createElementVNode("span", { class: "risk-label" }, "ВАШ РИСК", -1)),
        _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.riskLevel), 1)
      ], 4)
    ])
  ]))
}